import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute} from '@angular/router';
import { Globals } from '../../services/tools/Globals.service';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material';
import { AutenticacionService } from './../../services/autenticacion.service';
/*App imports*/
import { CreditosService } from "../../services/creditos.service";
import { HelpersService, TiposCreditos, EstatusCreditos } from '../../services/tools/helpers.service';
import { SucursalesService } from "../../services/sucursales.service";
import { EditarConvenioCreditComponent } from '../../components/tools/modals/editar-convenio-credit/editar-convenio-credit.component';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-listado-creditos',
  templateUrl: './listado-creditos.component.html',
  styleUrls: ['./listado-creditos.component.scss'], 
  providers: [NgbDropdownConfig]
})

export class ListadoCreditosComponent implements OnInit {

  errors:any = {};
  

  public isCobranza = false;
  //UI vars
  public listCreditos: any [] = [];
  public tiposCreditos: any = [];
  public sucursales: any[] = [];
  public isLoading: boolean = false;
  //Filters 
  public searchText: string = '';
  public selectedStatus: number = EstatusCreditos.Vigente; //Por default muestra los créditos vigentes
  public tipoCredito: any = null;
  public sucursal: any = null;
  public fechaFinal: any = null;
  public mostrarFechaFinal = false;


  //Pagination vars
  public page: number = 1;
  public pageSize: number = 0;
  public pageAll: number = 0;
  public paginationInfo = { from : null, to : null, total : null };
  //Datepicker
  public fechaInicio: any = null;
  public sucursalPorDefecto: string = "";

  constructor(
    private globals: Globals, 
    private route: ActivatedRoute,
    private router: Router,
    private creditosService: CreditosService,
    private helperService: HelpersService,
    private sucursalesService: SucursalesService,
    private dialog: MatDialog,
    private authService: AutenticacionService
    ){
   }

  ngOnInit() {
    
    this.getTiposCreditos();
    this.getSucursales();   
    this.checkUserPermissions();
    //this.getConteoTotalPorStatus();
  }

  public selectCredito(credito : any){
    let creditoUrl = '';
    switch(credito.idTipos_Creditos){
      case TiposCreditos.Hipotecario:
        creditoUrl = '/creditos/hipotecario/detalles/';
        break;
      case TiposCreditos.Automotriz:
        creditoUrl = '/creditos/automotriz/detalles/';
        break;
      case TiposCreditos.Prendario:
        creditoUrl = '/creditos/prendario/detalles/';
        break;
      case TiposCreditos.Verde:
        creditoUrl = '/creditos/verde/detalles/';
        break;
      case TiposCreditos.Personal:
        creditoUrl = '/creditos/personal/detalles/';
        break;
      case TiposCreditos.Nomina:
        creditoUrl = '/creditos/nomina/detalles/';
        break;
      case TiposCreditos.Carburacion:
        creditoUrl = '/creditos/carburacion/detalles/';
        break;
      case TiposCreditos.Estacionario:
        creditoUrl = '/creditos/estacionario/detalles/';
        break;
      case TiposCreditos.MesesSinIntereses:
        creditoUrl = '/creditos/comercializacion/detalles/';
        break;
      case TiposCreditos.PlusPension:
        creditoUrl = '/creditos/estacionario/detalles/';
      break;
    }
    this.router.navigate([creditoUrl, credito.id]);
  }

  private getCreditos(){
    let filters = this.getActiveFilters();
    console.log(filters)
    this.isLoading = true;

    this.creditosService.getAll(filters).subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        console.log(jsonResult)
        this.isLoading = false;
        
        if(jsonResult.content && jsonResult.content.data){
      
          const jsonContent = response.json().content;
          this.listCreditos = this.setupCreditLabels(jsonContent.data);

          this.page = jsonContent.current_page;
          this.pageSize = jsonContent.per_page;
          this.pageAll = jsonContent.total;
          this.paginationInfo.from = jsonContent.from;
          this.paginationInfo.to = jsonContent.to;
          this.paginationInfo.total = jsonContent.total;
        }

      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        this.isLoading = false;
        
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getActiveFilters(){
    let filters = {
      page : null,
      search : null,
      status : null,
      tipoCredito : null,
      sucursal : null,
      fechaInicio : null,
      per_page: null
    };

    if(this.page){
      filters.page = this.page;
    }

    if(this.searchText){
      filters.search = this.searchText;
    }

    if(this.selectedStatus){
      filters.status = this.selectedStatus;
    }

    if(this.tipoCredito){
      filters.tipoCredito = this.tipoCredito.id;
    }

    if(this.sucursal){
      filters.sucursal = this.sucursal.id;
    }

    if(this.fechaInicio){
      filters.fechaInicio = this.fechaInicio;
    }

    return filters;
  }

  private setupCreditLabels(listCreditos){
    listCreditos.forEach(function(credito) {
      switch(credito.statusCredito){
        case EstatusCreditos.Pendiente:
          credito.statusLabel = 'Pendiente';
          break;
        case EstatusCreditos.Vigente:
          credito.statusLabel = 'Vigentes';
          break;
        case EstatusCreditos.Finalizado:
          credito.statusLabel = 'Finalizado';
          break;
      }
    });
    return listCreditos;
  }

  /**
   * Populate catalogs
   */
  private getTiposCreditos(){
    this.creditosService.getTiposCreditos().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.tiposCreditos = jsonResult.content;
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private getSucursales(){
    this.isLoading = true;
    this.sucursalesService.get().subscribe(
      (response)=>
      {
        const jsonResult = response.json();
        if(jsonResult.content){
          this.sucursales = jsonResult.content.data;
          if (this.sucursales.length>1){
            this.sucursalPorDefecto = "Seleccione";
          } else if(this.sucursales.length>0){
            this.sucursal =  this.sucursales[0];
          }
          this.isLoading = false;
          this.getCreditos(); 
          this.getConteoTotalPorStatus();
        }
        
      }, error =>
      {
        // se resuelve error 403 y 500
        this.isLoading = false;
        this.helperService.httpGlobalError(error);

        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
  private checkUserPermissions() {
    this.isCobranza = this.authService.isCobranza();
  
}

  /**
   * Filters methods
   */
  searchKeyword(){
    //El keyword ingresado se obtiene directamente del modelo asociado
    this.getCreditos();
    this.getConteoTotalPorStatus();
  }

  statusChanged(selectedStatus : number){
    this.selectedStatus = selectedStatus;
    this.getCreditos();
    this.getConteoTotalPorStatus();
  }

  tipoCreditoChanged(tipoCredito){
    if(tipoCredito){
      this.tipoCredito = tipoCredito;
      this.getCreditos();
      this.getConteoTotalPorStatus();
    }
  }

  fechaInicioChanged(event){
    this.fechaInicio = event;
    this.getCreditos();
    this.getConteoTotalPorStatus();
  }
  

  sucursalChanged(sucursal){
    if(sucursal){
      this.sucursal = sucursal;
      this.getCreditos();
      this.getConteoTotalPorStatus();
    }
  }

  /**
   * Pagination methods
   */
  public pageChanged(event: any): void {
    if(event)
    {  
      this.getCreditos();
      this.getConteoTotalPorStatus();
    }
  }

  open_link_convenio(credit_id, convenio_id){
    const dialogRef = this.dialog.open(EditarConvenioCreditComponent, {
      height: 'auto',
      width: 'auto',
      data: { id:credit_id, convenio_id: convenio_id}
    });

    // dialogRef.afterClosed().subscribe(result => {
    //   if(result.eliminar){
    //     window.location.reload();
    //   }
    // });

  }


getConteoTotalPorStatus() {
  const filtros = this.getActiveFilters();

  this.creditosService.getConteoTotalPorStatus(filtros).subscribe(
    (res: any) => {
    //  console.log('Respuesta cruda de conteostatus:', res);

      const defaultCounts = { 1: 0, 2: 0, 3: 0 };
      const merged = { ...defaultCounts };

      Object.keys(res.content || {}).forEach(key => {
      const k = Number(key);
      merged[k] = res.content[key];
    });

      this.statusCounts = merged;
     // console.log('Conteo final mergeado:', this.statusCounts);
    },
    error => {
      console.error('Error al obtener conteo por estatus', error);
    }
  );
}

// 👉 Agregar esta línea:
public statusCounts: { [key: number]: number } = {
  1: 0,
  2: 0,
  3: 0
};



// imprimir tabla
// listado-creditos.component.ts
// imprimirTabla() {
  
//         //Imprimir pantalla
//         window.print();
    
// }

imprimirTabla(): void {
  if (!this.listCreditos || !this.listCreditos.length) {
    alert('No hay créditos que imprimir.');
    return;
  }

  let filasHTML = '';

  this.listCreditos.forEach(credito => {
    filasHTML += `
      <tr>
        <td>${credito.created_at}</td>
        <td>${credito.id}</td>
        <td>${credito.cliente ? credito.cliente.nombre : ''}</td>
        <td>${credito.cliente ? credito.cliente.email : ''}</td>
        <td>${credito.tipo_credito ? credito.tipo_credito.descripcion : ''}</td>
        <td>${credito.statusLabel}</td>
      </tr>
    `;
  });

  const ventana = window.open('', '', 'height=700,width=1000');
  if (ventana) {
    ventana.document.write(`
      <html>
        <head>
          <title>Lista de Créditos</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              font-size: 14px;
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              font-size: 11px;
            }
            th, td { 
              border: 1px solid #000; 
              padding: 8px; 
              text-align: left;
            }
            th { 
              background-color: #f2f2f2;
            }
            h2 {
              font-size: 18px;
            }
          </style>
        </head>
        <body>
          <h2>Lista de Créditos</h2>
          <table>
            <thead>
              <tr>
                <th>Fecha de inicio</th>
                <th>No. de contrato</th>
                <th>Nombre del cliente</th>
                <th>Correo electrónico</th>
                <th>Tipo de crédito</th>
                <th>Estatus</th>
              </tr>
            </thead>
            <tbody>
              ${filasHTML}
            </tbody>
          </table>
        </body>
      </html>
    `);
    ventana.document.close();
    ventana.print();
  }
}


getStatusNombre(): string {
  switch (this.selectedStatus) {
    case 1:
      return 'Pendientes';
    case 2:
      return 'Vigentes';
    case 3:
      return 'Finalizados';
    case 4:
      return 'Adjudicados';
    case 5:
      return 'Proceso Legal';
    case 6:
      return 'Cobranza Especial';
    default:
      return 'Todos';
  }
}

//Funcion para descargar el total de los creditos seleccionados

descargarExcelCompleto(): void {
  this.getCreditosTodasLasPaginas(true);
}


//funcion para llamar el total de lodos los creditos de cada estatus, pendiente, vigente y finalizados
private getCreditosTodasLasPaginas(descargarExcelAlFinal = false): void {
  let filters = this.getActiveFilters();
  const perPage = 100; // Puedes ajustar si tu API permite más
  filters.per_page = perPage;
  filters.page = 1;

  let todosLosRegistros: any[] = [];

  this.isLoading = true;

  const obtenerPagina = (page: number) => {
    filters.page = page;

    this.creditosService.getAll(filters).subscribe(
      (response) => {
        const jsonResult = response.json();
        const jsonContent = jsonResult.content;

        const registrosPagina = this.setupCreditLabels(jsonContent.data);
        todosLosRegistros = todosLosRegistros.concat(registrosPagina);

        const totalPages = jsonContent.last_page;
        //console.log(`Página ${page}/${totalPages}, acumulados: ${todosLosRegistros.length}`);

        if (page < totalPages) {
          obtenerPagina(page + 1);
        } else {
          this.isLoading = false;
        //  console.log('Todos los registros obtenidos:', todosLosRegistros.length);

          // Al terminar de traer todo
          if (descargarExcelAlFinal) {
            this.exportarExcelDesdeArray(todosLosRegistros);
          } else {
            // Si quieres dejarlos cargados en pantalla:
            this.listCreditos = todosLosRegistros;
          }
        }
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        this.isLoading = false;

        if (error.status === 400) {
          this.helperService.notification(
            'ERROR',
            'No se completó la acción. Por favor, intenta más tarde.',
            'error'
          );
        }
      }
    );
  };

  obtenerPagina(1);
}


//exporta la informacion total a excel

private exportarExcelDesdeArray(lista: any[]): void {
  if (!lista || !lista.length) {
    alert('No hay créditos que exportar.');
    return;
  }

  const datos = lista.map((credito) => ({
    'Fecha de inicio': credito.created_at,
    'Fecha de Liquidacion': credito.ultimo_pago ? credito.ultimo_pago.fecha : '',
    'No. de contrato': credito.id,
    'Nombre del cliente': credito.cliente ? credito.cliente.nombre : '',
    'Correo electrónico': credito.cliente ? credito.cliente.email : '',
    'Teléfono': credito.cliente && credito.cliente.telefono ? credito.cliente.telefono : '',
    'Tipo de crédito': credito.tipo_credito ? credito.tipo_credito.descripcion : '',
    // ✅ CORRECCIÓN AQUÍ: Validamos si existe el convenio antes de acceder a la propiedad
    'Convenio': (credito.convenio && credito.convenio.razon_social) ? credito.convenio.razon_social : 'SIN CONVENIO',
    // 🔹 Convertimos a número para que Excel lo reconozca como cantidad monetaria
    'Monto del crédito': credito.prestamo && credito.prestamo.monto_prestamo ? parseFloat(credito.prestamo.monto_prestamo) : 0,
    'Sucursal': credito.sucursal && credito.sucursal.nombre ? credito.sucursal.nombre : '',
    'Estatus': credito.statusLabel,
  }));

  const tipoCredito = this.getStatusNombre();
  const nombreLimpio = tipoCredito.replace(/\s+/g, '_');

  // Obtener fecha actual YYYY-MM-DD
  const hoy = new Date();
  const yyyy = hoy.getFullYear();
  const mm = String(hoy.getMonth() + 1).padStart(2, '0');
  const dd = String(hoy.getDate()).padStart(2, '0');
  const fechaActual = `${yyyy}-${mm}-${dd}`;

  // Armar nombre de archivo
  const nombreArchivo = `lista_creditos_${nombreLimpio}_${fechaActual}.xlsx`;

  const worksheet = XLSX.utils.json_to_sheet(datos);

  // 🔹 Aplicar formato de moneda ($#,##0.00) a la columna de Monto
  const range = XLSX.utils.decode_range(worksheet['!ref'] || 'A1');
  
  // Buscamos dinámicamente el índice de la columna "Monto" para aplicarle el formato
  for (let C = range.s.c; C <= range.e.c; ++C) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
    if (worksheet[cellAddress] && worksheet[cellAddress].v === 'Monto del crédito') {
      // Recorremos las filas de esta columna (a partir de la fila 1, omitiendo el encabezado)
      for (let R = range.s.r + 1; R <= range.e.r; ++R) {
        const rowCellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        if (worksheet[rowCellAddress]) {
          worksheet[rowCellAddress].z = '$#,##0.00'; // Formato de moneda nativo de Excel
        }
      }
    }
  }

  // 🔹 Calcular el ancho automático basado en el contenido
  const colWidths: { wch: number }[] = [];
  for (let C = range.s.c; C <= range.e.c; ++C) {
    let maxWidth = 10; 
    for (let R = range.s.r; R <= range.e.r; ++R) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = worksheet[cellAddress];
      if (cell && cell.v !== null && cell.v !== undefined) {
        let cellLength = String(cell.v).length;
        // Si es la columna de monto con formato, le damos un poco más de espacio por el signo de moneda y comas
        if (cell.z) {
          cellLength += 4;
        }
        if (cellLength > maxWidth) {
          maxWidth = cellLength;
        }
      }
    }
    colWidths.push({ wch: maxWidth + 3 });
  }
  worksheet['!cols'] = colWidths;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, `Créditos_${nombreLimpio}`);

  XLSX.writeFile(workbook, nombreArchivo);
}

  // fechaFinChanged(event: any) {
  //   this.tipoCredito = event;
  //   console.log("Tipo de crédito:", this.tipoCredito?.id);
  //   if (this.tipoCredito && this.tipoCredito.id === 3) {
  //     this.mostrarFechaFinal = true;
  //   } else {
  //     this.mostrarFechaFinal = true;
  //   }

  //   // Si quieres, aquí puedes volver a filtrar o recargar:
  //   // this.searchKeyword();
  // }

fechaFinalChanged(event: any) {
  this.fechaFinal = event;
}



}



// WEBPACK FOOTER //
// ./src/app/creditos/listado/listado-creditos.component.ts